import '../../modules/mode-components';

import * as angular from 'angular';

import { CollectionMoveToFacade } from '@mode/collections/domain';
import { Logger } from '@mode/shared/contract-common';
import MoveSpaceModalController from './move-space-modal-controller';
import template from './move-space-modal.html';

const moveSpaceDirective = function (Modal, ReportModel, $log: Logger, collectionMoveToFacade: CollectionMoveToFacade) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      owner: '<',
      account: '<',
      onMove: '&',
      movedToSpace: '&',
      onReportSpaceUpdate: '&?',
    },
    link: function ($scope: angular.IScope, elem, attrs) {
      function handleModal() {
        const modal = Modal.open(
          {
            spaces: null,
            owner: $scope.owner,
            account: $scope.account,
            currSpace: null,
            report: $scope.report,
          },
          {
            controller: MoveSpaceModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );

        modal.result
          .then((opts) => {
            const space = opts.$space;
            const currentSpace = opts.$currSpace;
            const handleMove = !opts.$noMove;

            if ($scope.onReportSpaceUpdate) {
              $scope.onReportSpaceUpdate({ $space: space });
            } else {
              const report = $scope.report;
              report.space_token = space.token;

              /**
               * When the LDFF "limit-report-property-list" is enabled the report layout
               * does not come back from the reports api used on the collections page.
               * To ensure that we don't send a blank "layout" as part of the move space
               * we need to explicitly nullify the layout.
               *
               * https://github.com/mode/issues/issues/14310
               */
              report.layout = null;

              ReportModel.update(report)
                .then((response) => {
                  collectionMoveToFacade.dispatch(CollectionMoveToFacade.Actions.moveToCollectionSuccess());
                  $scope.$evalAsync(() => {
                    $scope.onMove({ $space: space, $report: response._resource });
                    if (!handleMove) {
                      $scope.movedToSpace({ $space: space });
                    }
                  });
                })
                .catch((e) => {
                  collectionMoveToFacade.dispatch(CollectionMoveToFacade.Actions.moveToCollectionFailed());
                  $log.log('error saving report', e);
                });
            }
          })
          .catch(function () {});
      }

      elem.on('click.moveSpace', (event) => {
        handleModal();
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.moveSpace'));
    },
  };
};

moveSpaceDirective.$inject = ['ModalService', 'ReportModel', '$log', 'CollectionMoveToFacade'];

angular.module('mode.components').directive('moveSpace', moveSpaceDirective);
